<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33333 10.3333H4.34M10.3333 10.3333H10.34M16.3333 10.3333H16.34M4.66667 10.3333C4.66667 10.5174 4.51743 10.6667 4.33333 10.6667C4.14924 10.6667 4 10.5174 4 10.3333C4 10.1492 4.14924 10 4.33333 10C4.51743 10 4.66667 10.1492 4.66667 10.3333ZM10.6667 10.3333C10.6667 10.5174 10.5174 10.6667 10.3333 10.6667C10.1492 10.6667 10 10.5174 10 10.3333C10 10.1492 10.1492 10 10.3333 10C10.5174 10 10.6667 10.1492 10.6667 10.3333ZM16.6667 10.3333C16.6667 10.5174 16.5174 10.6667 16.3333 10.6667C16.1492 10.6667 16 10.5174 16 10.3333C16 10.1492 16.1492 10 16.3333 10C16.5174 10 16.6667 10.1492 16.6667 10.3333Z"
      stroke="currentColor"
      stroke-width="2.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
